import { Form } from "react-bootstrap";
import styles from "./styles.module.scss";

export default function Size(props) {
  const { rootNodePath, execute, handleChange } = props;

  return (
    <div className={styles.randomBox}>
      <div className={styles.select}>
        <div className={styles.label}>Operator</div>
        <div className={styles.content}>
          <Form.Control
            as="select"
            value={execute.operator}
            onChange={(e) => handleChange("operator", e)}
            name={`${rootNodePath}execute.otherFields.operator`}
            id={`${rootNodePath}execute.otherFields.operator`}
          >
            <option value=">">&gt;</option>
            <option value="=">=</option>
            <option value=">=">{">"}=</option>
            <option value="<">&lt;</option>
            <option value="<=">{"<="}</option>
          </Form.Control>
        </div>
      </div>
    </div>
  );
}
